<div class="row user-header">
  <div class="col-auto">
    <div class="user-image">
      <img *ngIf="isUserLoggedIn" [src]="userProfileModel.imageUrl ? userProfileModel.imageUrl : './assets/img/common/no-photo.png'" (click)="goToProfileDetail()">
      <img *ngIf="!isUserLoggedIn" src="/assets/img/common/no-photo.png" (click)="login()">
    </div>
  </div>
  <div class="col d-flex align-items-center p-0">
    <p *ngIf="isUserLoggedIn" class="user-info">
      {{ userProfileModel.name | usernameFormat }} <br>
      {{ userProfileModel.phone_no | thai2d3dPhone4 }}
    </p>
    <p *ngIf="!isUserLoggedIn" class="user-info" (click)="login()">{{ 'click_to_login' | translate }}</p>
  </div>
  <div class="col-auto pt-2" *ngIf="routerName == '/home' || routerName == '/game/list/'+providerId">
    <app-language-picker></app-language-picker>
  </div>
</div>

<div class="row user-balance-card mx-0"
     *ngIf="isUserLoggedIn && providerId == 11">
  <div class="col-12 px-0">
    <!-- CQ9 -->
    <div class="row align-items-center mx-0">
      <div class="col pr-0">
        <span>CQ9 {{ 'game_wallet_tran_text' | translate }} ({{ 'ks' | translate }})</span>

        <img
          (click)="toggleCQAmount(!showQCAmount)"
          [src]="showQCAmount ? 'assets/img/common/eye-icon.png' : 'assets/img/common/eye-off-icon.png'"
          class="st-icon"
        />

        <h3 *ngIf="!loadingCQBalance">
          {{ showQCAmount ? (showCQBalance | number:'1.2-2') : '*****' }}
        </h3>

        <ngx-spinner *ngIf="loadingCQBalance"
          [name]="common.loading.balanceLoading.name"
          [size]="common.loading.balanceLoading.size"
          [color]="common.loading.balanceLoading.color"
          [type]="common.loading.balanceLoading.type"
          [fullScreen]="common.loading.balanceLoading.fullScreen"
          [bdColor]="common.loading.balanceLoading.bdColor">
        </ngx-spinner>
      </div>

      <div class="col-auto pl-0">
        <button class="btn transfer-btn" (click)="selectFishGameListId(4)">
          <img src="assets/img/wallet/game_wallet.png" width="40">
          {{ 'game_balance_transfer' | translate }}
        </button>
      </div>
    </div>
    <hr class="wallet-divider">

    <!-- JILI -->
    <div class="row align-items-center mx-0 mt-2">
      <div class="col pr-0">
        <span>JILI {{ 'game_wallet_tran_text' | translate }} ({{ 'ks' | translate }})</span>

        <img
          (click)="toggleJLAmount(!showJLAmount)"
          [src]="showJLAmount ? 'assets/img/common/eye-icon.png' : 'assets/img/common/eye-off-icon.png'"
          class="st-icon"
        />

        <h3 *ngIf="!loadingJLBalance">
          {{ showJLAmount ? (showJILIBalance | number:'1.2-2') : '*****' }}
        </h3>

        <ngx-spinner *ngIf="loadingJLBalance"
          [name]="common.loading.balanceLoading.name"
          [size]="common.loading.balanceLoading.size"
          [color]="common.loading.balanceLoading.color"
          [type]="common.loading.balanceLoading.type"
          [fullScreen]="common.loading.balanceLoading.fullScreen"
          [bdColor]="common.loading.balanceLoading.bdColor">
        </ngx-spinner>
      </div>

      <div class="col-auto pl-0">
        <button class="btn transfer-btn" (click)="selectFishGameListId(5)">
          <img src="assets/img/wallet/game_wallet.png" width="40">
          {{ 'game_balance_transfer' | translate }}
        </button>
      </div>
    </div>

  </div>
</div>


<!-- <div class="row user-balance-card mx-0" *ngIf="isUserLoggedIn && providerId == 11">
  <div class="col pr-0">
    <span>CQ9 {{ 'game_wallet_tran_text' | translate }} ({{ 'ks' | translate }})</span>
    <img (click)="toggleCQAmount(!showQCAmount)" [src]="showQCAmount ? 'assets/img/common/eye-icon.png' : 'assets/img/common/eye-off-icon.png'" alt="" class="st-icon">
    <h3 *ngIf="!loadingCQBalance">{{ showQCAmount ? (showCQBalance | number : '1.2-2') : "*****" }}</h3>
    <ngx-spinner *ngIf="loadingCQBalance" [name]="common.loading.balanceLoading.name"
      [size]="common.loading.balanceLoading.size" [color]="common.loading.balanceLoading.color"
      [type]="common.loading.balanceLoading.type" [fullScreen]="common.loading.balanceLoading.fullScreen"
      [bdColor]="common.loading.balanceLoading.bdColor"></ngx-spinner>
  </div>
  <div class="col-auto d-flex align-items-center pl-0">
    <button class="btn transfer-btn" (click)="selectFishGameListId(4)">
      <img src="assets/img/wallet/game_wallet.png" alt="" width="40" height="auto"> {{ 'game_balance_transfer' | translate }}
    </button>
  </div>
</div>

<div class="row user-balance-card mx-0" *ngIf="isUserLoggedIn && providerId == 11">
  <div class="col pr-0">
    <span>JILI {{ 'game_wallet_tran_text' | translate }} ({{ 'ks' | translate }})</span>
    <img (click)="toggleJLAmount(!showJLAmount)" [src]="showJLAmount ? 'assets/img/common/eye-icon.png' : 'assets/img/common/eye-off-icon.png'" alt="" class="st-icon">
    <h3 *ngIf="!loadingJLBalance">{{ showJLAmount ? (showJILIBalance | number : '1.2-2') : "*****" }}</h3>
    <ngx-spinner *ngIf="loadingJLBalance" [name]="common.loading.balanceLoading.name"
      [size]="common.loading.balanceLoading.size" [color]="common.loading.balanceLoading.color"
      [type]="common.loading.balanceLoading.type" [fullScreen]="common.loading.balanceLoading.fullScreen"
      [bdColor]="common.loading.balanceLoading.bdColor"></ngx-spinner>
  </div>
  <div class="col-auto d-flex align-items-center pl-0">
    <button class="btn transfer-btn" (click)="selectFishGameListId(5)">
      <img src="assets/img/wallet/game_wallet.png" alt="" width="40" height="auto"> {{ 'game_balance_transfer' | translate }}
    </button>
  </div>
</div> -->

<div class="row user-balance-card mx-0" *ngIf="isUserLoggedIn && providerId != 11">
  <div class="col pr-0">
    <span>{{ 'game_wallet_tran_text' | translate }} ({{ 'ks' | translate }})</span>
    <img (click)="toggleAmount(!showAmount)" [src]="showAmount ? 'assets/img/common/eye-icon.png' : 'assets/img/common/eye-off-icon.png'" alt="" class="st-icon">
    <h3 *ngIf="!loadingBalance">{{ showAmount ? (showBalance | number : '1.2-2') : "*****" }}</h3>
    <ngx-spinner *ngIf="loadingBalance" [name]="common.loading.balanceLoading.name"
      [size]="common.loading.balanceLoading.size" [color]="common.loading.balanceLoading.color"
      [type]="common.loading.balanceLoading.type" [fullScreen]="common.loading.balanceLoading.fullScreen"
      [bdColor]="common.loading.balanceLoading.bdColor"></ngx-spinner>
  </div>
  <div class="col-auto d-flex align-items-center pl-0">
    <button class="btn transfer-btn" (click)="selectGameListId()">
      <img src="assets/img/wallet/game_wallet.png" alt="" width="40" height="auto"> {{ 'game_balance_transfer' | translate }}
    </button>
  </div>
</div>
 

 







